import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import UploadDialogForm from './UploadDialogForm';

const styles = () => ({
  form: {
    overflow: 'hidden',
    padding: 30,
  },
});

const UploadDialog = ({
  open,
  onClose,
  ID,
  onSubmitSuccess,
  form,
  title,
  subtitle,
  route,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle
      onCloseClick={onClose}
    >
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <UploadDialogForm
        className={classes.form}
        onSubmitSuccess={onSubmitSuccess}
        form={form}
        {...ID ? { ID } : {}}
        subtitle={subtitle}
        route={route}
      />
    </DialogContent>
  </Dialog>
);

UploadDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  form: PropTypes.string,
  ID: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  route: PropTypes.string,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

UploadDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  form: 'uploadForm',
  initialValues: null,
  ID: null,
  title: 'Upload File',
  subtitle: null,
  route: null,
};

export default withStyles(styles)(UploadDialog);



// WEBPACK FOOTER //
// ./src/components/settings/UploadDialog/UploadDialog.js